export default function Packages() {
  const packages = [
    {
      tier: "High-Velocity Diagnostic Audit",
      price: "$5,000",
      timeline: "Single-day on-site engagement",
      audience:
        "Facilities that need a clear read on bottlenecks, regulatory exposure, and layout constraints before investing in a larger overhaul.",
      deliverables: [
        "On-site evaluation of active workflow bottlenecks and floor friction.",
        "Assessment of regulatory exposure risks and layout constraints.",
        "Waste Elimination Blueprint with prioritized, high-ROI structural remedies.",
      ],
    },
    {
      tier: "Process Architecture & Layout Overhaul",
      price: "$10,000",
      timeline: "Full-scale system reconfiguration",
      audience:
        "Cosmetics, ammunition, and refrigeration operations ready to redesign floors, lines, and visual controls for lasting efficiency gains.",
      deliverables: [
        "System reconfiguration modeling for thermal envelope, packaging lines, and material flow.",
        "Visual factory controls engineered to cut logistical search times by up to 90%.",
        "Line balancing and layout changes that unlock measurable throughput improvements.",
      ],
    },
    {
      tier: "Enterprise Turnkey Operational Transformation",
      price: "$15,000",
      timeline: "End-to-end transformation oversight",
      audience:
        "Organizations seeking full integration, error-proofing, and training to lock in permanent annualized labor savings.",
      deliverables: [
        "End-to-end change management and operational integration oversight.",
        "Tailored simulation modules and error-proofing (Poka-Yoke) controls.",
        "Team training that sustains process gains after the engagement ends.",
      ],
    },
  ];

  return (
    <div className="container relative py-16 md:py-36 flex lg:flex-row flex-col">
      <div className="flex-col justify-start items-start flex w-full">
        <div className="mb-12 flex-col justify-center text-center items-center gap-2 inline-flex w-full">
          <div className="p-2 bg-[#e6f1ff] rounded-md justify-center items-center gap-2 inline-flex">
            <div className="text-[#2b8cff] text-base font-medium font-secondary leading-[19px]">
              PACKAGES
            </div>
          </div>
          <div className="text-center text-[#0e0e0e] text-2xl md:text-[32px] font-semibold font-primary leading-[41.60px]">
            Fixed-Value Engagement Packages
          </div>
          <div className="text-center text-[#373737] text-base md:text-xl font-light font-primary leading-7 tracking-[0.01em] max-w-[720px]">
            Three clear engagement levels — from a one-day diagnostic to a
            full operational transformation — with transparent flat-fee pricing.
          </div>
        </div>

        <div className="gap-6 items-stretch justify-center flex flex-wrap flex-col lg:flex-row w-full">
          {packages.map((pkg) => (
            <div
              key={pkg.tier}
              className="p-6 flex-col justify-start items-start gap-5 inline-flex w-full lg:w-[calc(33.333%-16px)] lg:max-w-[380px] bg-gray-50 rounded-md border border-transparent hover:border-[#00479C] transition-all duration-500"
            >
              <div className="flex-col justify-start items-start gap-2 flex">
                <div className="text-[#0e0e0e] text-xl font-normal font-primary leading-7">
                  {pkg.tier}
                </div>
                <div className="text-[#0075ff] text-2xl font-semibold font-primary leading-8">
                  {pkg.price}
                </div>
                <div className="text-[#64748b] text-sm font-light font-primary leading-5 tracking-[0.01em]">
                  {pkg.timeline}
                </div>
              </div>

              <div className="text-[#373737] text-base font-light font-primary leading-[22.40px] tracking-[0.01em]">
                {pkg.audience}
              </div>

              <ul className="flex-col justify-start items-start gap-3 flex w-full list-none p-0 m-0">
                {pkg.deliverables.map((item) => (
                  <li
                    key={item}
                    className="text-[#373737] text-sm font-light font-primary leading-[19.60px] tracking-[0.01em] flex gap-2"
                  >
                    <span className="text-[#0075ff] mt-0.5 shrink-0">•</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <button
          onClick={() =>
            window.open(
              "https://calendly.com/charismaticconsultingar/",
              "_blank"
            )
          }
          className="p-3 justify-center items-center gap-1.5 flex bg-[#0075ff] hover:bg-[#0E0E0E] transition-all duration-300 rounded mx-auto mt-10 md:mt-16"
        >
          <div className="text-white text-base font-semibold font-primary leading-5">
            Schedule Your Free Consultation
          </div>
          <img
            src="https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/Frame-e3d7af35-d90e-4bcb-89fd-9563341bc0a1.svg"
            alt=""
          />
        </button>

        <img
          src="https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/Rectangle2-cd111b85-d21e-4815-a11e-997879004c0f.svg"
          alt=""
          className="absolute right-[22px] top-0 opacity-90 w-10 md:w-auto"
        />
      </div>
    </div>
  );
}
